import { gql, useLazyQuery } from "@apollo/client"
import DownloadLinkFields from "~/app/queries/fragments/DownloadLinkFields"
import { Company, QueryCompanyArgs, QueryInvoiceArgs } from "@oysterhr/schema"
import { InjectedOptions } from "@oysterhr/core"

export const QUERY = gql`
  ${DownloadLinkFields}
  query CompanySingleInvoice($companyId: ID!, $invoiceId: ID!, $isStaff: Boolean!) {
    company(companyId: $companyId) {
      id
      invoice(invoiceId: $invoiceId) {
        id
        company {
          id
          name
        }
        amount {
          currencyCode
          subunit
        }
        amountDue {
          currencyCode
          subunit
        }
        totalAmount {
          currencyCode
          subunit
        }
        prePaidAmount {
          currencyCode
          subunit
        }
        amountCurrencyCode
        autoApprovedAt
        createdAt
        dueDate
        invoiceDate
        paymentPeriod
        notes
        referenceCode
        sentAt
        paidAt
        voidedAt
        state
        chargePaymentRequest {
          id
          ordersState
          targetAmount {
            currencyCode
            subunit
          }
        }
        payoutPaymentRequest {
          id
          idempotencyKey @include(if: $isStaff)
          timeline {
            bankAccount
            status
            events {
              name
              completedAt
            }
          }
          viewState
          targetAmount {
            currencyCode
            subunit
          }
        }
        kind
        subkind
        isOverdue
        creditNoteApplications {
          id
          createdAt
          amountUsed {
            subunit
            currencyCode
          }
          appliedCreditNote {
            id
            referenceCode
          }
        }
        file {
          ...DownloadLinkFields
        }
        supportingFile {
          ...DownloadLinkFields
        }
      }
    }
  }
`

type LazyQueryInvoiceArgs = QueryCompanyArgs & QueryInvoiceArgs & { isStaff: boolean }

export const useInvoiceLazyQuery = (
  options?: InjectedOptions<{ company: Pick<Company, "invoice"> }, LazyQueryInvoiceArgs>,
) => useLazyQuery<{ company: Pick<Company, "invoice"> }, LazyQueryInvoiceArgs>(QUERY, options)
